
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/data-security-laws-quick-reference",
      function () {
        return require("private-next-pages/compliance/resources/data-security-laws-quick-reference.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/data-security-laws-quick-reference"])
      });
    }
  